import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    goTopWrapper:{
        position:'absolute',
        bottom: 60,
        right: 24,
        backgroundColor: "#FFFFFF",
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: "#EEEEEE",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowRadius: 8,
        shadowColor: "rgba(0,0,0,0.08)",
        elevation: 8,
        width: 44,
        height: 44,
        borderRadius: 44,
        alignItems: 'center',
        justifyContent: 'center'
    },
    goTopIcon:{
        height: 24
    }
});